import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=207b7fdd&"
import script from "./Tree.vue?vue&type=script&lang=js&"
export * from "./Tree.vue?vue&type=script&lang=js&"
import style0 from "./Tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports